import { Input } from 'antd';

const { TextArea } = Input;

export default TextArea;